import { render, staticRenderFns } from "./LabelValueListItem.vue?vue&type=template&id=9f78f434&scoped=true&"
import script from "./LabelValueListItem.vue?vue&type=script&lang=ts&"
export * from "./LabelValueListItem.vue?vue&type=script&lang=ts&"
import style0 from "./LabelValueListItem.vue?vue&type=style&index=0&id=9f78f434&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f78f434",
  null
  
)

export default component.exports